import React, { useState } from "react";
import { useUpdateFeedBack } from "./store";
import { useBookingData } from "modules/nextcall/store";
import { useNavigate } from "react-router-dom";
import useActionableListStore from "../actionable_list/store";
import { toast } from "react-toastify";
import { useCallingStore } from 'modules/navbar/top/store/store';
import { Button } from 'antd';

function SaveFeedBack({ orderCount, week, formData, renderedComponents, id, customerId, setShow, setBooking, setData, setActiveOrder, disabled = false}) {
  const { disposeAllCalls } = useCallingStore();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const engagementType = urlSearchParams.get("subTab");
  const { fetchTodayEngData, fetchTempEngData } = useActionableListStore();
  const currentUrl = window.location.href.split("/");
  const navigate = useNavigate();
  const { fetchBookingData } = useBookingData();
  const [feedbackButton, setFeedbackButton] = useState({text: "Save Feedback",variant: "primary"});
  const [saveFlag, setSaveFlag] = useState(0);

  const { updateFeedback, markAdhocCallDone } = useUpdateFeedBack();
  const createReqObj = () => {
    if (["unanswered", "languageIssue", "dndMode"].includes(formData?.callResponse)) {
      if(formData?.callResponse === "unanswered"){
        let relatedWeek = week === "Onboarding Call" ? "SLOT_BOOKING" : week;
        if(week === "Slot Booking Lead"){
          relatedWeek = "SLOT_BOOKING"
        }
        if(week === 'CUSTOMER_COMPLAINT_BOOKING'){
          const _comment = `${relatedWeek} engagement marked as unanswered because ${formData.comments}`;
          return { is_answered: "false", comment: _comment, response: {tag: week} };
        }
        return {
          is_answered: "false",
          comment: `${relatedWeek} engagement marked as unanswered`,
          response: {
            comment:`${relatedWeek} engagement marked as unanswered`,
            dnd: formData?.dnd || false,
            ...formData,
          },
        };
      }else if(formData?.callResponse === "languageIssue"){
        return {
          comment: `Language barrier: ${formData.languageBarrier}`,
          preferedLanguage: formData.languageBarrier,
        };
      } else {
        return {
          is_answered: "false",
          comment: `${week} engagement marked as unanswered with DND Mode`,
          response: {
            comment:`${week} engagement marked as unanswered with DND Mode`,
            note: formData.comments,
            dnd: true
          },
        };
      }
    } else if (week === "Prescription Call") {
      return {
        comment: `answered(${week}): ${formData.comments}`,
        is_answered: "true",
        response: {
          comment: formData.comments,
          language: formData?.language || "N/A",
          kitInfoFlag: formData?.kitInfoFlag,
          dosageInfoFlag: formData?.dosageInfoFlag,
          topical_os_informed: formData?.topical_os_informed,
          healthCondition: formData?.healthCondition || "N/A",
          healthConditionComment: formData?.healthConditionComment || "N/A",
          prevSupplementConsumed: formData?.prevSupplementConsumed || "N/A",
          prevSupplementComment: formData?.prevSupplementComment || "N/A",
          beforeTreatment: formData?.beforeTreatment || "N/A",
          treatmentOtherComment: formData?.treatmentOtherComment || "N/A",
          breakUpTimelineExpectation: formData?.breakUpTimeline,
          crmMentionedTime: formData?.crmMentionedTime || "N/A",
          crmMentionedTimeComments: formData?.crmMentionedTimeComments || "N/A",
          minoxidilInformed: formData?.minoxidilInformed,
          appInfo: formData?.appInfo,
          herbalFlag: formData?.herbalFlag,
          treatmentStart: formData?.treatmentStart,
          queryInfo: formData?.queryInfo,
          interested_in_community: formData?.interested_in_community,
        },
      };
    } else if (week === "Onboarding Call") {
      return {
        comment: `answered(SLOT_BOOKING): ${formData.comments}`,
        is_answered: "true",
        response: {
          comment: formData.comments,
          language: formData?.language || "N/A",
          kitInfoFlag: formData?.kitInfoFlag,
          dosageInfoFlag: formData?.dosageInfoFlag,
          topical_os_informed: formData?.topical_os_informed,
          healthCondition: formData?.healthCondition || "N/A",
          healthConditionComment: formData?.healthConditionComment || "N/A",
          prevSupplementConsumed: formData?.prevSupplementConsumed || "N/A",
          prevSupplementComment: formData?.prevSupplementComment || "N/A",
          beforeTreatment: formData?.beforeTreatment || "N/A",
          treatmentOtherComment: formData?.treatmentOtherComment || "N/A",
          breakUpTimelineExpectation: formData?.breakUpTimeline,
          crmMentionedTime: formData?.crmMentionedTime || "N/A",
          crmMentionedTimeComments: formData?.crmMentionedTimeComments || "N/A",
          minoxidilInformed: formData?.minoxidilInformed,
          appInfo: formData?.appInfo,
          herbalFlag: formData?.herbalFlag,
          treatmentStart: formData?.treatmentStart,
          queryInfo: formData?.queryInfo,
          interested_in_community: formData?.interested_in_community,
        },
      };
    } else if (week === "Slot Booking Lead") {
      return {
        comment: `answered(SLOT_BOOKING)`,
        is_answered: "true",
        response: {
          ...formData,
        },
      };
    } else if (week === "CUSTOMER_COMPLAINT_BOOKING") {
      return {comment: formData.comments, is_answered: 'true', response: {tag: week,doctor_intervention_required: formData.doctor_intervention_required || false,}}
    } else if(week === 'ADHOC_CALL'){
      return {
        comment: formData.comments,
        is_answered: formData.callResponse === 'answered'? 'true': 'false',
        response: {
          ...formData,
        },
      };
    } else if(week === 'Clinic Slot'){
      return {
        comment: `answered( SLOT_BOOKING): ${formData.comments}`,
        is_answered: formData.callResponse === 'answered'? 'true': 'false',
        response: {
          ...formData,
        },
      };
    }
    else {
      return {
        comment: `answered(${week}): ${formData.comments}`,
        is_answered: "true",
        response: {
          mood: formData.mood,
          customer_adherence: formData.regularity,
          adherence_reason: formData.reason || "N/A",
          any_product_reaction: formData.reaction,
          ...(formData.category && { sub_category: formData.category }),
          gut_health: formData.gutHealth,
          energy: formData.energy,
          hair_loss: formData.hairLoss,
          hair_growth: formData.hairGrowth,
          ...(formData.reasonForNotOrdering && {
            not_ordering_reason: formData.reasonForNotOrdering,
          }),
          comment: formData.comments ? formData.comments.trim() : "",
          product_reaction: formData.reactions ? formData.reactions.trim() : "",
          interested_in_community: formData?.interested_in_community,
          doctor_intervention_required: formData.doctor_intervention_required || false,
        },
      };
    }
  };
  const emptyFields = renderedComponents?.filter((component) => {
    return !component.value;
  });
  const handleSubmit = () => {
    const feedback = createReqObj();
    disposeAllCalls();
    if(week === 'ADHOC_CALL'){
      markAdhocCallDone(customerId, feedback, setShow);
      return;
    }
    setSaveFlag(saveFlag + 1);
    if(saveFlag){
      toast.warn("Please wait, Feedback is saving");
      return;
    }
    currentUrl.includes("next-call")
    ? updateFeedback( setShow, id, feedback, setFeedbackButton, fetchTodayEngData, fetchTempEngData, fetchBookingData, setData, setBooking, customerId, engagementType, navigate, null)
      : updateFeedback( setShow, id, feedback, setFeedbackButton, fetchTodayEngData, fetchTempEngData, fetchBookingData, setData, setBooking, customerId, engagementType, null, setActiveOrder);
  };
  return (
    <div className="mt-5 mb-3 text-center w-100">
      {emptyFields.length ? 
        <div className="fw-bold text-danger">
          Please give input for {emptyFields.map(field => field.name).join(' ,')}.
        </div> :
          <Button type={feedbackButton.variant} onClick={handleSubmit} style={{width:'100%'}} disabled={disabled}>
            {orderCount === 1 && week === "SLOT_BOOKING" ? "Save" : feedbackButton.text}
          </Button>
      }
    </div>
  );
}

export default SaveFeedBack;